import { Skeleton } from "@/components/atoms";
import { usePricingProfileContext, useZoneRatesContext, ZoneRatesEditPanel } from "@/components/organisms";
import { Restricted } from "@/components/pages/Restricted/Restricted";

export const ZoneRatesEdit = () => {
  const { isFetching: isFetchingPricingProfile, isRestricted: isRestrictedPricingProfile, pricingProfile } = usePricingProfileContext();
  const { isFetching: isFetchingZoneRates, isRestricted: isRestrictedZoneRates, activeZone: zone } = useZoneRatesContext();
  const isFetching = isFetchingPricingProfile || isFetchingZoneRates;
  const isRestricted = isRestrictedPricingProfile || isRestrictedZoneRates;

  if (isFetching) {
    return (
      <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
      {isRestricted ? <Restricted /> : ((pricingProfile && zone) && <ZoneRatesEditPanel pricingProfile={pricingProfile} zone={zone} />)}
    </div>
  );
};